import { render, staticRenderFns } from "./Paginacao.vue?vue&type=template&id=07020c03&scoped=true"
import script from "./Paginacao.vue?vue&type=script&lang=js"
export * from "./Paginacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07020c03",
  null
  
)

export default component.exports